<template>
  <div class='coursework-viewer__description-panel'>
    <div class='coursework-viewer__description-panel_close'>
      <a class='kd-ibtn kf-ibtn--bg-dark' href="javascript:;" @click="toggleDescription" v-tooltip="{content: 'Close', position: 'bottom'}">
        <i class='kf kf-x'></i>
      </a>
    </div>
    <a class='coursework-viewer__description-panel_header_user'>
      <div class='coursework-viewer__description-panel_header_user_avatar'>
        <img :src="author.avatar">
      </div>
      <div class='coursework-viewer__description-panel_header_user_name' v-tabkeyfocus="true">{{author.name}}</div>
    </a>
    <div class='coursework-viewer__description-panel_headline'>{{work.title}}</div>
    <div class='coursework-viewer__description-panel_content'>{{work.subtitle}}</div>
    <div class='coursework-viewer__description-panel_content' v-if="media.length > 0">
      <div>{{media.length}} files submitted</div>
      <ul>
        <li v-for="file in mediaFileList" :key="file">{{file}}</li>
      </ul>
    </div>
    <div class='coursework-viewer__description-panel_headline'>Description</div>
    <div class='coursework-viewer__description-panel_content'>{{work.description}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      author: Object,
      work: Object,
      media: Array
    },
    data() {
      return {
        
      }
    },
    computed: {
      mediaFileList() {
        if (this.media.length > 0) {
          let exts = _.map(this.media, function (media) {
            return _.isEmpty(media.extension) ? null : media.extension.substring(1);
          });
          return _.map(_.pairs(_.countBy(_.compact(exts), function(ext) { return ext; })), function(pair) { return `${pair[1]} ${pair[0].pluralize(pair[1])}`; });
        } else {
          return [];
        }        
      }
    },
    methods: {
      toggleDescription() {
        this.$emit('toggleDescription')
      }
    }
  }
</script>